import { Box, Grid } from '@mui/system';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { CustomContainer, CustomScalarSpreadsheet } from 'components';
import { SummaryProps } from './Summary.props';

export const Summary = ({
  companySummarySheetProps,
  companySummary,
  isFetching,
  rowGroups,
  setRowGroups,
  containerClassName,
  hasExpandedRowGroup,
}: SummaryProps) => (
  <Box sx={{ pt: 3 }}>
    <CustomContainer className={clsx(containerClassName, { expanded: hasExpandedRowGroup })}>
      {companySummarySheetProps && Boolean(companySummary) && !isEmpty(companySummary) && (
        <Grid size={{ xs: 12 }}>
          <CustomScalarSpreadsheet
            {...companySummarySheetProps}
            isLoading={isFetching}
            rowGroups={rowGroups}
            setRowGroups={setRowGroups}
          />
        </Grid>
      )}
    </CustomContainer>
  </Box>
);
